export const RoleIcons = {
  default: require('./default.png'),

  NANNY: require('./NANNY.png'),
  STAFF: require('./STAFF.png'),
  GARDN: require('./GARDN.png'),
  INTRWR: require('./INTRWR.png'),
  TAILR: require('./TAILR.png'),
  VEGVEN: require('./VEGVEN.png'),
  FBALL: require('./FBALL.png'),
  BBALL: require('./BBALL.png'),
  TENNIS: require('./TENNIS.png'),
  SKATE: require('./SKATE.png'),
  MUSIC: require('./MUSIC.png'),
  DANCE: require('./DANCE.png'),
  DOGWLK: require('./DOGWLK.png'),
  LAUNDR: require('./LAUNDR.png'),
  YOGA: require('./YOGA.png'),
  BEAUTY: require('./BEAUTY.png'),
  HAIRD: require('./HAIRD.png'),
  FLOWER: require('./FLOWER.png'),
  CARPEN: require('./CARPEN.png'),
  ACREPR: require('./ACREPR.png'),
  APREPR: require('./APREPR.png'),
  PAINT: require('./PAINT.png'),
  MEDSH: require('./MEDSH.png'),
  GROC: require('./GROC.png'),
  NURSE: require('./NURSE.png'),
  ELCARE: require('./ELCARE.png'),
  PHYSIO: require('./PHYSIO.png'),
  MAID: require('./MAID.png'),
  NEWSDP: require('./NEWSDP.png'),
  CARCLN: require('./CARCLN.png'),
  TUTION: require('./TUTION.png'),
  TAEK: require('./TAEK.png'),
  ELECT: require('./ELECT.png'),
  CCTVTC: require('./CCTVTC.png'),
  FIREOF: require('./FIREOF.png'),
  BOUNCR: require('./BOUNCR.png'),
  PESTCT: require('./PESTCT.png'),
  WTCLNR: require('./WTCLNR.png'),
  BABYST: require('./BABYST.png'),
  AMBUL: require('./AMBUL.png'),
  ROWATR: require('./ROWATR.png'),
  MILKVD: require('./MILKVD.png'),
  PHOTO: require('./PHOTO.png'),
  DRIVER: require('./DRIVER.png'),
  PLUMB: require('./PLUMB.png'),
  COOK: require('./COOK.png'),

  OTHER: require('./default.png'),
};